import React, { FC } from 'react';
import { Translate, I18n } from 'react-redux-i18n';

import ShopCard from '@ui/ShopCard';

import { TeacherCardProps } from './interfaces';

export const Plus = ({ children }) => (
  <div className="plan-plus">
    <i className="plus" aria-hidden="true" />
    {children}
  </div>
);

const BodyCard = (
  <>
    <Plus>
      <Translate value="shop.teacher.1" />
    </Plus>
    <Plus>
      <Translate value="shop.teacher.2" />
    </Plus>
    <Plus>
      <Translate value="shop.teacher.3" />
    </Plus>
    <Plus>
      <Translate value="shop.teacher.4" />
    </Plus>
    <Plus>
      <Translate value="shop.teacher.5" />
    </Plus>
    <Plus>
      <Translate value="shop.teacher.6" />
    </Plus>
  </>
);

const TeacherCard: FC<TeacherCardProps> = ({ user }) => {
  return <ShopCard title={I18n.t('shop.teacher.header')} body={BodyCard} />;
};

export default TeacherCard;
